import LanguageTitleLinkField from "./language-title-link-field";
import LanguageStatusField from "./language-status-field";
import LanguageActionField from "./language-action-field";


const LanguageFields = {
    TitleLink: LanguageTitleLinkField,
    Status: LanguageStatusField,
    Action: LanguageActionField,
};

export default LanguageFields;
